import React, { useState } from 'react';
import { Layout, Button, Typography, theme, Grid } from 'antd';
import { MenuOutlined } from '@ant-design/icons';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { useAuth } from '../contexts/AuthContext';

const { Header, Content } = Layout;
const { Text } = Typography;
const { useBreakpoint } = Grid;

export function AppLayout() {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(true);
  const { token } = theme.useToken();
  const { user } = useAuth();
  const screens = useBreakpoint();
  const isMobile = !screens.md;

  const toggleSidebar = () => setSidebarCollapsed(!sidebarCollapsed);

  const siderWidth = 200;

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sidebar
        collapsed={isMobile ? sidebarCollapsed : false}
        isMobile={isMobile}
        onClose={() => setSidebarCollapsed(true)}
      />
      <Layout style={{ marginLeft: isMobile ? 0 : siderWidth }}>
        <Header
          style={{
            padding: '0 16px',
            background: token.colorBgContainer,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            borderBottom: `1px solid ${token.colorBorderSecondary}`,
            position: 'sticky',
            top: 0,
            zIndex: 10,
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
            {isMobile && (
              <Button
                type="text"
                icon={<MenuOutlined />}
                onClick={toggleSidebar}
                style={{ fontSize: 16 }}
              />
            )}
            {!isMobile && (
              <Text strong style={{ fontSize: 14 }}>CBS Support</Text>
            )}
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            {user && (
              <>
                <Text strong>{user.username}</Text>
                {!isMobile && (
                  <Text type="secondary">({user.role})</Text>
                )}
              </>
            )}
          </div>
        </Header>
        <Content style={{ margin: isMobile ? 8 : 16 }}>
          <div
            style={{
              padding: isMobile ? 16 : 24,
              minHeight: 'calc(100vh - 64px - 32px)',
              background: token.colorBgContainer,
              borderRadius: token.borderRadiusLG,
            }}
          >
            <Outlet />
          </div>
        </Content>
      </Layout>
    </Layout>
  );
}
